<!--
Drawer component
Usage: <Drawer title='Things' />
@author cm359n
-->
<template>
    <div id="mymodal" :class="'modal-background modal-bg' + (showing ? '-show' : '-hide')">
        <div :class="'uog-drawer drawer' + (showing ? '-show' : '-hide')">
            <div class="drawer-top">&nbsp;</div>
            <span class="drawer-header">{{ title }}</span>
            <span class="drawer-header-right">
              <button class="drawer-close-button" v-if="showCloseButton" @click="doCancel()">
              <font-awesome-icon style="color:#727483;" icon="close" size="lg"></font-awesome-icon>
              </button>
            </span>
            <div class="drawer-content">
                <slot></slot>
            </div>
        </div>
    </div>
</template>
<script>

export default {
  name: 'Drawer',
  props: ['toggle', 'title', 'showCloseButton'],
  components: {
  },
  data () {
    return {
      showing: this.toggle
    }
  },
  // mixins: [StringUtil, AssFeedCommon],
  mounted () {

  },
  methods: {
    doCancel () {
      console.log('closing')
      this.$emit('doCancel')
    }
  }
}

</script>
<style lang="scss" scoped>
@import '@/scss/common-styles.scss';
  .modal-bg-show {
    visibility: visible;
  }
  .modal-bg-hide {
    visibility: hidden;
  }
  .modal-background {
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgb(0,0,0); /* fallback colour */
    background-color: rgba(0,0,0,0.2); /* black with opacity */
  }
  .drawer-content {
    margin-left: 30px;
    margin-right: 30px;
    margin-bottom: 15px;
  }
  .drawer-top {
    height: 40px;
    background-color: white;
    border-top-left-radius: 40px;
    border-top-right-radius: 40px;
}
  .uog-drawer {
    position: fixed;
   bottom: 45px;
    width: 100%;
    background-color: white;
     border-top-left-radius: 40px;
    border-top-right-radius: 40px;
 }
  .drawer-show {
    visibility: visible;
  }
  .drawer-hide {
    visibility: hidden;
  }
  .drawer-header {
    margin-left: 30px;
    margin-bottom: 15px;
    font-size: 20px;
    font-weight: 700;
    color: #003865;
  }
  .drawer-header-right {
    float: right;
    margin-right: 30px;
  }
  .drawer-close-button {
    border: 0;
    color: #727483;
  }

</style>
